import { apiFetch, expectJsonBody } from "@common/lib/api";
import type { BillingPlan, BillingInvoice } from "@common/utils/types";

export async function fetchBillingPlan(): Promise<BillingPlan> {
    return expectJsonBody(await apiFetch<BillingPlan>("billing/plan"), "GET billing/plan");
}

export async function fetchBillingInvoices(): Promise<BillingInvoice[]> {
    return expectJsonBody(await apiFetch<BillingInvoice[]>("billing/invoices"), "GET billing/invoices");
}

export async function createPortalSession(): Promise<{ url: string }> {
    return expectJsonBody(
        await apiFetch<{ url: string }>("billing/portal-session", {
            method: "POST",
        }),
        "POST billing/portal-session",
    );
}

export async function createBillingCheckoutSession(params: {
    price_id: string;
    quantity?: number;
    mode: "upgrade" | "addon" | "new_subscription";
}): Promise<{ url: string }> {
    return expectJsonBody(
        await apiFetch<{ url: string }>("billing/checkout-session", {
            method: "POST",
            json: params,
        }),
        "POST billing/checkout-session",
    );
}
